/*
 * @providesModule FriendsNewBanner
 * 
 */

import React from 'react';
import I18n from 'INTL';
import Label from 'Label';
import styles from 'FriendsNewBannerStyles';

import {
  View,
} from 'react-native';

export default class FriendsNewBanner extends React.PureComponent {

  render(): React.ReactNode {

    return (
      <View style={styles.container}>
        <View style={styles.triangleCorner}/>
        <Label style={styles.text}>
          {I18n.message('NEW')}
        </Label>
      </View>
    );
  }
}
